import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { CarrierVisitDirection } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (
    carrierVisitDirection: M extends true ? CarrierVisitDirection[] : CarrierVisitDirection,
  ) => void
} & TomAutoCompleteProps<CarrierVisitDirection, M>

export const CarrierVisitDirectionAutoComplete = observer(
  <M extends boolean = false>(props: Props<M>) => {
    const { t } = useTranslate()
    const { dataCy, defaultValue, label, onChange } = props

    const [options] = useState<CarrierVisitDirection[]>(Object.values(CarrierVisitDirection))

    return (
      <TomAutoComplete
        {...props}
        dataCy={dataCy ?? 'carrier-visit-direction-autocomplete'}
        label={label ?? t('direction', 'Direction')}
        options={options}
        defaultValue={defaultValue}
        enablePortal
        placeholder={t('selectDirection', 'Select direction')}
        onChangeEntity={entity => {
          onChange(entity as M extends true ? CarrierVisitDirection[] : CarrierVisitDirection)
        }}
      />
    )
  },
)
